const mainRouter = [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/dataView/index'),
    meta: { title: '智能客服后台' },
    children: [
      {
        path: '/dataview',
        name: 'dataview',
        component: () => import('@/views/dataView/dataView.vue'),
      },
      {
        path: '/hotanalyze',
        name: 'hotanalyze',
        component: () => import('@/views/dataView/hotAnalyze.vue'),
      },
      {
        path: '/combo',
        name: 'combo',
        component: () => import('@/views/dataView/comboInfo.vue'),
      },
      {
        path: '/usermanager',
        name: 'usermanager',
        component: () => import('@/views/acount/userManager.vue'),
      },
      {
        path: '/rolemanager',
        name: 'rolemanager',
        component: () => import('@/views/acount/roleManage.vue'),
      },
      {
        path: '/acountinfo',
        name: 'acountinfo',
        component: () => import('@/views/acount/acountInfo.vue'),
      },
      {
        path: '/setclassis',
        name: 'setclassis',
        component: () => import('@/views/aimManager/setClassis.vue'),
      },
      {
        path: '/slotlists',
        name: 'slotlists',
        component: () => import('@/views/aimManager/slotLists.vue'),
      },
      {
        path: '/aimlists',
        name: 'aimlists',
        component: () => import('@/views/aimManager/aimLists.vue'),
      },
      {
        path: '/setacount',
        name: 'setacount',
        component: () => import('@/views/setBase/setAcount.vue'),
      },
      {
        path: '/outmanager',
        name: 'outmanager',
        component: () => import('@/views/setBase/outManager.vue'),
      },
      {
        path: '/guess',
        name: 'guess',
        component: () => import('@/views/setBase/guess.vue'),
      },
      {
        path: '/reply',
        name: 'reply',
        component: () => import('@/views/setBase/reply.vue'),
      },
      {
        path: '/scenelanguage',
        name: 'scenelanguage',
        component: () => import('@/views/setBase/sceneLanguage.vue'),
      },
      {
        path: '/siteaccess',
        name: 'siteaccess',
        component: () => import('@/views/setBase/siteAccess.vue'),
      }, {
        path: '/rules',
        name: 'rules',
        component: () => import('@/views/setBase/rules.vue'),
      },
      {
        path: '/sendrecord',
        name: 'sendrecord',
        component: () => import('@/views/messageManager/sendRecord.vue'),
      },
      {
        path: '/messageasign',
        name: 'messageasign',
        component: () => import('@/views/messageManager/messageAsign.vue'),
      },
      {
        path: '/messagetemplate',
        name: 'messagetemplate',
        component: () => import('@/views/messageManager/messageTemplate.vue'),
      },
      {
        path: '/messagesetting',
        name: 'messagesetting',
        component: () => import('@/views/messageManager/messageSetting.vue'),
      },
      {
        path: '/messagekey',
        name: 'messagekey',
        component: () => import('@/views/messageManager/messageKey.vue'),
      },
      {
        path: '/sessionrecord',
        name: 'sessionrecord',
        component: () => import('@/views/session/sessionRecord.vue'),
      },
      {
        path: '/callrecord',
        name: 'callrecord',
        component: () => import('@/views/session/callRecord.vue'),
      },
      {
        path: '/userlists',
        name: 'userlists',
        component: () => import('@/views/userInfo/index.vue'),
      },
      {
        path: '/versionlists',
        name: 'versionlists',
        component: () => import('@/views/version/index.vue'),
      },
      {
        path: '/quickAnswer',
        name: 'quickAnswer',
        component: () => import('@/views/aimManager/quickAnswer.vue')
      }
    ],
  },
  {
    path: '/openAccount',
    name: 'openAccount',
    component: () => import('@/views/openAccount/index')
  }
]
export default mainRouter
